import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';
import LandingSection from '@spotahome/landings-common/src/components/LandingSection';

import GuaranteesCoverDesktop from './GuaranteesCoverDesktop';
import GuaranteesCoverMobile from './GuaranteesCoverMobile';
import MedalIcon from './Icons/MedalIcon';
import EnvelopeIcon from './Icons/EnvelopeIcon';
import EyeIcon from './Icons/EyeIcon';
import LockIcon from './Icons/LockIcon';
import ExclamationMarkIcon from './Icons/ExclamationMarkIcon';

import './GuaranteesCover.scss';

const COVERS = [
  {
    titleKey: 'tenant_guarantees.cover.1.title',
    textKey: 'tenant_guarantees.cover.1.text',
    renderIcon: () => <MedalIcon />
  },
  {
    titleKey: 'tenant_guarantees.cover.2.title',
    textKey: 'tenant_guarantees.cover.2.text',
    renderIcon: () => <EnvelopeIcon />
  },
  {
    titleKey: 'tenant_guarantees.cover.3.title',
    textKey: 'tenant_guarantees.cover.3.text',
    renderIcon: () => <EyeIcon />
  },
  {
    titleKey: 'tenant_guarantees.cover.4.title',
    textKey: 'tenant_guarantees.cover.4.text',
    cta: {
      textKey: 'tenant_guarantees.cover.4.cta.text',
      routeId: 'tenant_guarantees'
    },
    renderIcon: () => <LockIcon />
  },
  {
    titleKey: 'tenant_guarantees.cover.5.title',
    textKey: 'tenant_guarantees.cover.5.text',
    renderIcon: () => <ExclamationMarkIcon />
  }
];

const GuaranteesCover = ({ deviceType = null }) => {
  const isDesktop =
    deviceType === 'desktop' || deviceType === 'bot' || !deviceType;

  return (
    <LandingSection className="tenant-guarantees-cover">
      <h2 className="tenant-guarantees-cover__title">
        {trans('tenant_guarantees.cover.title')}
      </h2>
      {isDesktop ? (
        <GuaranteesCoverDesktop covers={COVERS} />
      ) : (
        <GuaranteesCoverMobile covers={COVERS} />
      )}
    </LandingSection>
  );
};

GuaranteesCover.propTypes = {
  deviceType: PropTypes.string
};

export default GuaranteesCover;
